<script>
import { adjustSlugFromTitle, adjustStorySlugByPath } from '@/mixins/lib/textFormat'

export default {
    name: 'CircleButton',
    props: {
        author: String,
        slug: String,
        text: String,
        id: [Number, Object], 
    },
    data: () => ({
        toggle: false
    }),
    render(h) { 
        const { text, slug, href, click } = this

        return h('button-more', {
            props: {
                class: this.type,
                label: `${text} information about ${slug}`,
                text,
                href,
            },
            nativeOn: {
                click,
            },
        })
    },
    methods: {
        click(event) {
            this.$parent.$el.classList.add( 'is-selected', 'is-visited' )

            if ( this.href ) {
                event.preventDefault()
            }

            const cb = () => this.$router.push(this.href)

            if ( this.isMobile() ) {
                cb()
            } 
            else {
                this.$root.$emit('show-stories', {id: this.id, cb})
            }
        },
        videoAfterPathFill() {
            const pathStage = parseInt(this.id.id[1]) - 1

            return this.$root.$emit('slide-recruit-progress', { 
                stage: pathStage,
                onComplete: () => {
                    setTimeout(() => {
                        this.$root.$emit('fullscreen-award-play', 'award-wining')
                    }, 200)
                },
            })
        },
        handleVideoClick() {
            if ( this.isMobile() || !this.$route.path.includes('recruit') ) {
                return this.$root.$emit('fullscreen-award-play', 'award-wining')
            }
            
            return this.videoAfterPathFill()
        },
    },
    computed: {
        href() {
            if ( this.type ) {
                const { eContentLink: name } = this.$store.getters
                const { href } = this.$router.resolve({ name })
                return href
            }
            const { path } = this.$route
            const storySlug = adjustSlugFromTitle(this.slug)
            const adjustedSlug = adjustStorySlugByPath(storySlug, path)

            if ( adjustedSlug.includes('create-your-own')) {
                return adjustedSlug
            }

            return `${adjustedSlug}-${this.author.toLowerCase().replace('_', '-')}`
        },
        type() {
            return Array.isArray(this.id.id) 
                ? this.id.id[0] 
                : null
        },
    },
}
</script>